import { queryOptions } from "@tanstack/react-query";
import { getNotificationSummary } from "@/lib/actions/notifications";
import { isServerActionNotFoundError } from "@/lib/serverActionUtils";

/**
 * 쿼리 키에 Clerk user id 를 넣는다 — QueryClient 는 브라우저 싱글턴이라 모달 로그인으로 계정을 바꾸면
 * 같은 키의 이전 계정 캐시가 stale 아닌 채 그대로 보인다. 전체 무효화는 `all` 접두사로 한다.
 */
export const NOTIFICATION_QUERY_KEYS = {
  all: ["notifications"] as const,
  unread: (userId: string | null) => ["notifications", "unread", userId] as const,
  list: (userId: string | null) => ["notifications", "list", userId] as const,
};

/** 이전 탭의 Action ID는 재시도로 복구되지 않으므로 새로고침까지 자동 조회를 멈춘다. */
export function notificationSummaryQueryOptions(userId: string | null, signedIn: boolean) {
  return queryOptions({
    queryKey: NOTIFICATION_QUERY_KEYS.unread(userId),
    queryFn: getNotificationSummary,
    enabled: (query) => signedIn && !isServerActionNotFoundError(query.state.error),
    staleTime: 30_000,
    retry: (failureCount, error) =>
      !isServerActionNotFoundError(error) && failureCount < 2,
    refetchInterval: (query) =>
      isServerActionNotFoundError(query.state.error) ? false : 60_000,
    refetchOnWindowFocus: true,
  });
}
